import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------ English ------------------------------ */
i18next.addResources(locales.EN, 'CONTACT_SETTINGS_VIEW', {
  TITLE: 'Contact Settings',
  SAVE: 'Save',
  CONTACT_TITLE: 'Contact Settings',
  SAVE_SUCCESS: 'Settings saved successfully',
  SAVE_ERROR: 'Error saving settings',
});

/* ------------------------------ Spanish ------------------------------ */
i18next.addResources(locales.ES, 'CONTACT_SETTINGS_VIEW', {
  TITLE: 'Configuración de Contacto',
  SAVE: 'Guardar',
  CONTACT_TITLE: 'Configuración de Contacto',
  SAVE_SUCCESS: 'Configuración guardada exitosamente',
  SAVE_ERROR: 'Error al guardar',
});
